/* WebComponentLabelPrintingLoader template */
import { h } from '@stencil/core';

const WebComponentLabelPrintingLoaderTsx = (context) => {
    let I18N = context.ref.I18N;

    return (
      <dia-loader-overlay>
        <dia-loader
          data-progress={ context.ref.loadingProgress }
          data-message={ context.ref.loadingMessage || I18N.t("Es wird geladen...") }
          data-state={ context.ref.loadingState }
          data-information={ context.ref.loadingInformation }
        >
        </dia-loader>
      </dia-loader-overlay>
    );
};

export default WebComponentLabelPrintingLoaderTsx;
